export const PeoplChatBubbleIcon = ({ className, onClickFunction, style, ...rest }) => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            onClick={onClickFunction}
            style={style}
            {...rest}
        >
            <path d="M4.5 12.5H12.5V10.5H4.5V12.5ZM4.5 9.5H16.5V7.5H4.5V9.5ZM4.5 6.5H16.5V4.5H4.5V6.5ZM0.5 20.5V2.5C0.5 1.95 0.695833 1.47917 1.0875 1.0875C1.47917 0.695833 1.95 0.5 2.5 0.5H18.5C19.05 0.5 19.5208 0.695833 19.9125 1.0875C20.3042 1.47917 20.5 1.95 20.5 2.5V14.5C20.5 15.05 20.3042 15.5208 19.9125 15.9125C19.5208 16.3042 19.05 16.5 18.5 16.5H4.5L0.5 20.5ZM3.65 14.5H18.5V2.5H2.5V15.625L3.65 14.5Z" fill="#60D744"/>
        </svg>
    );
};

export const PeoplLocBubbleIcon = ({ className, onClickFunction, style, ...rest }) => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            onClick={onClickFunction}
            style={style}
            {...rest}
        >
            <path d="M10.5 20.5C9.11667 20.5 7.81667 20.2375 6.6 19.7125C5.38333 19.1875 4.325 18.475 3.425 17.575C2.525 16.675 1.8125 15.6167 1.2875 14.4C0.7625 13.1833 0.5 11.8833 0.5 10.5C0.5 9.11667 0.7625 7.81667 1.2875 6.6C1.8125 5.38333 2.525 4.325 3.425 3.425C4.325 2.525 5.38333 1.8125 6.6 1.2875C7.81667 0.7625 9.11667 0.5 10.5 0.5C11.8833 0.5 13.1833 0.7625 14.4 1.2875C15.6167 1.8125 16.675 2.525 17.575 3.425C18.475 4.325 19.1875 5.38333 19.7125 6.6C20.2375 7.81667 20.5 9.11667 20.5 10.5C20.5 11.8833 20.2375 13.1833 19.7125 14.4C19.1875 15.6167 18.475 16.675 17.575 17.575C16.675 18.475 15.6167 19.1875 14.4 19.7125C13.1833 20.2375 11.8833 20.5 10.5 20.5ZM10.5 16C11.25 15.25 11.9167 14.475 12.5 13.675C13 12.9917 13.4583 12.2417 13.875 11.425C14.2917 10.6083 14.5 9.8 14.5 9C14.5 7.9 14.1083 6.95833 13.325 6.175C12.5417 5.39167 11.6 5 10.5 5C9.4 5 8.45833 5.39167 7.675 6.175C6.89167 6.95833 6.5 7.9 6.5 9C6.5 9.8 6.70833 10.6083 7.125 11.425C7.54167 12.2417 8 12.9917 8.5 13.675C9.08333 14.475 9.75 15.25 10.5 16ZM10.5 10.5C10.0833 10.5 9.72917 10.3542 9.4375 10.0625C9.14583 9.77083 9 9.41667 9 9C9 8.58333 9.14583 8.22917 9.4375 7.9375C9.72917 7.64583 10.0833 7.5 10.5 7.5C10.9167 7.5 11.2708 7.64583 11.5625 7.9375C11.8542 8.22917 12 8.58333 12 9C12 9.41667 11.8542 9.77083 11.5625 10.0625C11.2708 10.3542 10.9167 10.5 10.5 10.5Z" fill="#60D744"/>
        </svg>
    );
};

export const PeoplJoinBubbleIcon = ({ className, onClickFunction, style, ...rest }) => {
    return (
        <svg
            width="25"
            height="25"
            viewBox="0 0 25 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            onClick={onClickFunction}
            style={style}
            {...rest}
        >
            <rect width="25" height="25" rx="4" fill="#60D744"/>
            <path d="M15.125 4.625H18.625C19.0891 4.625 19.5342 4.80937 19.8624 5.13756C20.1906 5.46575 20.375 5.91087 20.375 6.375V18.625C20.375 19.0891 20.1906 19.5342 19.8624 19.8624C19.5342 20.1906 19.0891 20.375 18.625 20.375H15.125" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M10.75 16.875L15.125 12.5L10.75 8.125" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M15.125 12.5H4.625" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    );
};
